// The public demo atlas: a welcome that says everything is made up, and a few one-click tours.
import { html, Modal, closeModal, openModal } from './common.js';
import { me, viewer, setOpts, tab, model, showHydro, showWater, geology } from '../store.js';

const SEEN = 'atlas.demo.welcomed';

export function maybeWelcome() {
  if (!me.value?.demo || !me.value?.visitor) return;
  try { if (localStorage.getItem(SEEN)) return; localStorage.setItem(SEEN, '1'); } catch { /* private mode: show it */ }
  openModal('demowelcome');
}

function allSurveys() { return new Set((model.value?.surveys || []).map((_, i) => i)); }

const TOURS = [
  ['Fly into the cave', 'See the passages under a see-through ground, coloured by depth.', () => {
    tab.value = 'passages'; setOpts({ opacity: 0.25, xray: true, colorBy: 'depth', walls: true });
    viewer.flyToSurveys(allSurveys());
  }],
  ['Follow the water', 'Stream channels, the stream through the cave, the dye trace and where it all drains.', () => {
    tab.value = 'water'; showHydro(true); showWater('channels', true); showWater('routes', true); showWater('links', true);
    setOpts({ opacity: 0.5 }); viewer.view('oblique');
  }],
  ['The rock it\'s in', 'Colour the passages by formation: the cave follows the base of the limestone.', () => {
    tab.value = geology.value ? 'geology' : 'passages'; setOpts({ colorBy: geology.value ? 'formation' : 'year', opacity: 0.3, xray: true });
    viewer.flyToSurveys(allSurveys());
  }],
  ['How it was found', 'Colour by survey year: eight surveys from 1968 to 2018.', () => {
    tab.value = 'passages'; setOpts({ colorBy: 'year', opacity: 0.25, xray: true }); viewer.flyToSurveys(allSurveys());
  }],
];

export function DemoWelcome() {
  const go = (fn) => { closeModal(); setTimeout(fn, 50); };
  return html`<${Modal} title="Welcome to the demo atlas" footer=${html`<button class="btn primary" onClick=${closeModal}>Start exploring</button>`}>
    <p style="margin-top:0">This is a working copy of a caving club's 3D atlas, filled with <b>made-up data</b>: an invented valley,
      an invented cave (Echo Hollow Cave, 4 km of passage) and the kind of records a club keeps: entrances, sinkholes, a dig,
      bat counts, a dye trace and trip reports. The real atlas holds real surveys and is open only to the club's members.</p>
    <p class="small muted">Look around freely: nothing you do here changes anything. Drag to turn the view, right-drag to slide it,
      scroll to zoom, and click anything for its details.</p>
    <div class="sect">Try</div>
    <div class="list">${TOURS.map(([t, d, fn]) => html`<button class="row-btn" onClick=${() => go(fn)}>
      <span class="dot" style="background:var(--accent, #f07d4c)"></span><span style="min-width:0"><div class="t">${t}</div><div class="s">${d}</div></span></button>`)}</div>
    <p class="tiny muted" style="margin-bottom:0">The ground was generated by a program (a folded limestone valley, streams and sinkholes) and its coordinates
      are in the Atlantic Ocean on purpose. <a href="#" onClick=${(e) => { e.preventDefault(); closeModal(); openModal('howto'); }}>How to use the atlas</a></p>
  <//>`;
}
